(function () {
  'use strict';

  var root = document.getElementById('SoulyshinePupPopup');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  var teaser = document.getElementById('SoulyshinePupTeaser');

  var DAY = 24 * 60 * 60 * 1000;
  var TWO_DAYS = 48 * 60 * 60 * 1000;
  var DISMISS_KEY = 'ss_pup_quiz_dismissed_until';
  var OPTED_KEY = 'ss_pup_quiz_opted_in';
  var MANUAL_OPEN_PARAM = 'soulyshine_pup_quiz';
  var state = { selected: null, shoppingFor: 'Myself', optedIn: false, expiresAt: 0, countdownTimer: null };
  var lastFocused = null;
  var manualOpenRequested = false;

  try {
    manualOpenRequested = new URLSearchParams(window.location.search).get(MANUAL_OPEN_PARAM) === 'open';
  } catch (e) {}

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pose]'));
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-popup-step]'));
  var form = root.querySelector('[data-popup-form]');
  var emailInput = form.querySelector('input[type="email"]');
  var error = root.querySelector('[data-form-error]');
  var submitButton = root.querySelector('[data-submit-button]');

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function setCookie(name, value, seconds) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + seconds + '; SameSite=Lax';
  }

  function getCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) return decodeURIComponent(parts[i].slice(prefix.length));
    }
    return null;
  }

  function dismissedUntil() {
    return Number(storageGet(DISMISS_KEY) || getCookie(DISMISS_KEY) || 0);
  }

  function alreadyOptedIn() {
    return storageGet(OPTED_KEY) === '1' || getCookie(OPTED_KEY) === '1';
  }

  function isEligibleNow() {
    return !state.optedIn && !alreadyOptedIn() && dismissedUntil() <= Date.now();
  }

  function withTimeout(promise, milliseconds, fallback) {
    return Promise.race([
      promise,
      new Promise(function (resolve) { window.setTimeout(function () { resolve(fallback); }, milliseconds); })
    ]);
  }

  function isKnownKlaviyoProfile() {
    if (root.dataset.customerKnown === 'true') return Promise.resolve(true);
    if (!window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return Promise.resolve(false);
    try {
      return withTimeout(Promise.resolve(window.klaviyo.isIdentified()), 2500, false)
        .then(function (known) { return Boolean(known); })
        .catch(function () { return false; });
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  function showStep(name) {
    steps.forEach(function (step) { step.hidden = step.dataset.popupStep !== name; });
  }

  function hideTeaser() {
    if (!teaser) return;
    teaser.hidden = true;
    teaser.setAttribute('aria-expanded', 'false');
  }

  function showTeaser() {
    if (!teaser || state.optedIn || alreadyOptedIn() || root.dataset.suppressed === 'known-profile') return;
    teaser.hidden = false;
    teaser.setAttribute('aria-expanded', 'false');
  }

  function clearManualOpenRequest() {
    if (!manualOpenRequested || !window.history || typeof window.history.replaceState !== 'function') return;
    try {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete(MANUAL_OPEN_PARAM);
      window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    } catch (e) {}
    manualOpenRequested = false;
  }

  function openPopup(ignoreDismissal) {
    if (state.optedIn || alreadyOptedIn() || (!ignoreDismissal && !isEligibleNow()) || !root.hidden) return;
    lastFocused = document.activeElement;
    hideTeaser();
    root.hidden = false;
    if (teaser) teaser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ss-pup-is-open');
    showStep('pick');
    window.setTimeout(function () {
      var firstCard = root.querySelector('[data-pose]');
      if (firstCard) firstCard.focus({ preventScroll: true });
    }, 30);
  }

  function closePopup() {
    if (root.hidden) return;
    root.hidden = true;
    document.body.classList.remove('ss-pup-is-open');
    if (!state.optedIn) {
      var until = Date.now() + DAY;
      storageSet(DISMISS_KEY, String(until));
      setCookie(DISMISS_KEY, String(until), 86400);
      showTeaser();
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
  }

  function copyPoseToResult(card) {
    state.selected = card;
    var image = card.querySelector('img');
    var color = card.dataset.color;
    var deep = card.dataset.deep;

    root.querySelector('[data-result-name]').textContent = card.dataset.name;
    root.querySelector('[data-result-verdict]').textContent = card.dataset.verdict;

    ['result', 'gift'].forEach(function (prefix) {
      var visual = root.querySelector('[data-' + prefix + '-visual]');
      var hero = root.querySelector('[data-' + prefix + '-image]');
      visual.dataset.pose = card.dataset.pose;
      visual.style.setProperty('--panel', color);
      hero.src = image.src;
      hero.alt = card.dataset.product + ' charm';
      root.querySelector('[data-' + prefix + '-bubble]').textContent = card.dataset.bubble;
      root.querySelector('[data-' + prefix + '-bubble-two]').textContent = card.dataset.bubbleTwo;
      root.querySelector('[data-' + prefix + '-product]').textContent = card.dataset.product + ' charm · from $35';
    });

    Array.prototype.slice.call(root.querySelectorAll('.ss-pup__primary')).forEach(function (button) {
      button.style.setProperty('--deep', deep);
    });

    var productLink = root.querySelector('[data-product-link]');
    productLink.href = card.dataset.url;
    productLink.innerHTML = 'Find my breed in ' + card.dataset.short + ' <span>→</span>';
  }

  function selectPose(card) {
    copyPoseToResult(card);
    showStep('reveal');
    window.setTimeout(function () { emailInput.focus({ preventScroll: true }); }, 30);
  }

  function setShoppingFor(value, activeButton) {
    state.shoppingFor = value;
    Array.prototype.slice.call(root.querySelectorAll('[data-shopping]')).forEach(function (button) {
      var active = button === activeButton;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function subscriptionPayload(email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Soulyshine Homepage Pup Quiz Popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                properties: {
                  'Pup Personality': state.selected.dataset.name,
                  'Shopping For': state.shoppingFor,
                  'Welcome Offer': 'GIFT10'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: root.dataset.listId } } }
      }
    };
  }

  function startCountdown() {
    window.clearInterval(state.countdownTimer);
    state.expiresAt = Date.now() + TWO_DAYS;

    function tick() {
      var left = Math.max(0, state.expiresAt - Date.now());
      var hours = Math.floor(left / 3600000);
      var minutes = Math.floor(left / 60000) % 60;
      var seconds = Math.floor(left / 1000) % 60;
      root.querySelector('[data-countdown]').textContent = [hours, minutes, seconds]
        .map(function (part) { return String(part).padStart(2, '0'); })
        .join(':');
    }

    tick();
    state.countdownTimer = window.setInterval(tick, 1000);
  }

  function submitSubscription(event) {
    event.preventDefault();
    var email = emailInput.value.trim();
    error.hidden = true;
    emailInput.removeAttribute('aria-invalid');

    if (!validEmail(email)) {
      emailInput.setAttribute('aria-invalid', 'true');
      error.textContent = 'Please enter a valid email address.';
      error.hidden = false;
      emailInput.focus();
      return;
    }

    submitButton.disabled = true;
    submitButton.firstChild.textContent = 'Sending… ';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
      method: 'POST',
      headers: {
        'accept': 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify(subscriptionPayload(email))
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
      state.optedIn = true;
      hideTeaser();
      storageSet(OPTED_KEY, '1');
      setCookie(OPTED_KEY, '1', 31536000);
      storageSet(DISMISS_KEY, '0');
      setCookie(DISMISS_KEY, '0', 0);

      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        try {
          window.klaviyo.identify({
            email: email,
            'Pup Personality': state.selected.dataset.name,
            'Shopping For': state.shoppingFor,
            'Welcome Offer': 'GIFT10'
          });
        } catch (e) {}
      }

      copyPoseToResult(state.selected);
      showStep('gift');
      startCountdown();
    }).catch(function () {
      error.textContent = 'We could not save your email. Please try again.';
      error.hidden = false;
    }).finally(function () {
      submitButton.disabled = false;
      submitButton.firstChild.textContent = 'Send my 10% off ';
    });
  }

  cards.forEach(function (card) { card.addEventListener('click', function () { selectPose(card); }); });
  Array.prototype.slice.call(root.querySelectorAll('[data-popup-close]')).forEach(function (button) { button.addEventListener('click', closePopup); });
  Array.prototype.slice.call(root.querySelectorAll('[data-shopping]')).forEach(function (button) { button.addEventListener('click', function () { setShoppingFor(button.dataset.shopping, button); }); });
  root.querySelector('[data-pick-again]').addEventListener('click', function () { showStep('pick'); });
  form.addEventListener('submit', submitSubscription);
  emailInput.addEventListener('input', function () { error.hidden = true; emailInput.removeAttribute('aria-invalid'); });
  document.addEventListener('click', function (event) {
    var teaserTrigger = event.target.closest ? event.target.closest('#SoulyshinePupTeaser') : null;
    if (!teaserTrigger) return;
    event.preventDefault();
    openPopup(true);
    window.setTimeout(function () {
      var liveRoot = document.getElementById('SoulyshinePupPopup');
      if (liveRoot && liveRoot.hidden && teaserTrigger.href) window.location.assign(teaserTrigger.href);
    }, 80);
  });

  root.querySelector('[data-copy-code]').addEventListener('click', function (event) {
    var label = event.currentTarget.querySelector('span');
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText('GIFT10').catch(function () {});
    label.textContent = 'Copied! ✓';
  });

  root.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  var eligibility = isKnownKlaviyoProfile().then(function (known) {
    if (known) {
      root.dataset.suppressed = 'known-profile';
      hideTeaser();
    } else if (manualOpenRequested) {
      openPopup(true);
      clearManualOpenRequest();
    } else if (dismissedUntil() > Date.now() && !alreadyOptedIn()) {
      showTeaser();
    }
    return !known;
  });

  window.setTimeout(function () {
    eligibility.then(function (eligible) { if (eligible) openPopup(); });
  }, 3000);

  document.addEventListener('mouseout', function (event) {
    if (event.relatedTarget || event.toElement || event.clientY > 8) return;
    eligibility.then(function (eligible) { if (eligible) openPopup(); });
  });
})();
